import React from 'react';
import { IMaskInput } from 'react-imask';

interface Props extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  value: string;
}

const CpfMask = React.forwardRef<HTMLInputElement, Props>(
  function CpfMask(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000.000.000-00"
        inputRef={ref}
        onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  }
);

export default CpfMask;
